import { useMutation } from "@tanstack/react-query";
import { programApi } from "@bw/shared/api";
import type { UnifiedEnrollmentResponse } from "@bw/shared/types/generated";
import type { ProgramEnrollBody } from "@bw/shared/api";

/**
 * Enroll the caller in a track (POST /programs/tracks/{track_id}/enroll). The
 * router forces student_id = caller and track_id = path; the generated body
 * carries selections, opaque raw/fee quote references and optional age/card.
 *
 * The backend owns durable reservation, payment intent and recovery. Its
 * response status is authoritative. SCA/uncertain retries reuse their exact
 * original generated body rather than minting a different reviewed purchase.
 */
export function useEnroll(trackId: string | undefined) {
  return useMutation<UnifiedEnrollmentResponse, unknown, ProgramEnrollBody>({
    mutationFn: (body: ProgramEnrollBody) =>
      programApi.enroll(trackId as string, body),
  });
}
